import { Page } from '@/constants/routes';

export interface HubNavFlags {
  approvalEnabled: boolean;
  isReader: boolean;
  isCreator: boolean;
  projectCollectionsEnabled: boolean;
  processingEnabled: boolean;
}

const PROCESSING_HREFS = ['/processing', '/fr-CA/processing'];

/**
 * Apply the Hub nav visibility rules. Pure function so the rules can be unit
 * tested without rendering the header. Mirrors the rules previously inlined in
 * header.tsx, plus the enable_hub_processing gate.
 */
export function filterHubNavPages(pages: Page[], flags: HubNavFlags): Page[] {
  return pages.filter(value => {
    if (value.href === '/approvals' || value.href === '/fr-CA/approvals') {
      return flags.approvalEnabled && !flags.isReader;
    }
    if (value.href === '/metrics' || value.href === '/fr-CA/metrics') {
      return !flags.isCreator && !flags.isReader;
    }
    if (value.href === '/projects' || value.href === '/fr-CA/projects') {
      return flags.projectCollectionsEnabled;
    }
    if (PROCESSING_HREFS.includes(value.href)) {
      return flags.processingEnabled;
    }
    return true;
  });
}
